<app-icon-and-button-card cardTitle="Your order is confirmed!" imagePath="assets/img/check-pink.svg">
  @if (patientName) {
    <p class="mt-4" data-qa-id="Patient First Name">{{ patientName | titlecase }},</p>
  }
  @if (hasMandatoryLabResult) {
    <p class="mt-4">
      Thank you for filling out the Medical Questionnaire. Our Physicians will review your responses and contact you
      with your prescription via email ASAP.
    </p>
  } @else {
    <div>
      @if (isInHomeCollection) {
        <div>
          <p class="mt-4">Thank you for choosing In Home Collection.</p>
        </div>
      } @else {
        <div>
          <p class="mt-4">Thank you for filling out the Medical Questionnaire and selecting your lab location.</p>
          <p class="mt-4">
            Your lab requisition has been sent to your email. Please bring it with you (printed or on your phone) when
            you visit the lab.
          </p>
        </div>
      }
      <p class="mt-4">
        Once your results are ready, our medical team will review them and notify you about the next steps.
      </p>
      <p class="mt-4">
        If you have any questions, contact us at
        <a href="mailto:{{ contactEmail }}" class="card-link" data-qa-id="Contact Email">{{ contactEmail }}</a> or
        message us directly in your account.
      </p>
    </div>
  }
  @if (transactionId) {
    <p class="mt-4" data-qa-id="Consultation Order Number">
      Your order number is: <strong>{{ transactionId }}</strong
      >.
    </p>
  }

  @if (payments === null) {
    <div class="has-text-centered mt-4" data-qa-id="Payments History Spinner">
      <em class="fa fa-spinner fa-spin"></em>
    </div>
  }
  @if (payments && payments.length) {
    <section class="transaction-history-summary" data-qa-id="Transaction History Summary">
      <p class="mt-5">Here's the transaction summary for your order:</p>
      <div class="tabs mt-3 mb-2">
        <ul class="is-justify-content-center">
          <li class="is-active"><a>Order summary</a></li>
        </ul>
      </div>

      <div class="table-container">
        <table class="table is-fullwidth">
          <tbody>
            @for (payment of payments; track $index) {
              <tr>
                <td>{{ payment.processed_at | date: 'MM/dd/yy' }}</td>
                <td class="payment-detail-row">{{ payment.detail }}</td>
                <td>{{ payment.amount / 100 | currency }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }

  <div button-container class="is-flex is-justify-content-center is-flex-direction-column-mobile mt-6">
    @if (payments && payments.length) {
      <button
        [disabled]="loadingButton"
        (click)="downloadInvoice()"
        class="card-button button is-rounded is-primary is-primary-outlined mr-2"
        data-qa-id="Secondary Card Button"
        type="button"
      >
        @if (!loadingButton) {
          <span>Download Invoice</span>
        } @else {
          <span><em class="fa fa-spinner fa-spin"></em></span>
        }
      </button>
    }
    <button (click)="redirect()" class="card-button button is-rounded is-primary" data-qa-id="Card Button">
      Back to Home
    </button>
  </div>
</app-icon-and-button-card>
